import React, { useRef, useEffect } from 'react';
import { Chart, ArcElement, DoughnutController } from 'chart.js';

import styles from './Account.module.css';

Chart.register(ArcElement, DoughnutController);



export default function KraProgressChart({
  kra_amount = 0,   // 当前值
  max_value = 100000,   // 上限
  width = 342.539,
  height = 142,
}) {
  const canvasRef = useRef(null);
   const formatNumbers = (num) => {
              if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
              if (num >= 1000)   return (num / 1000).toFixed(0) + 'K';
              return num.toString();
            };

  useEffect(() => {
    const ctx = canvasRef.current.getContext('2d');

    // 小圆圈指示器插件
    const circleIndicator = {
      id: 'circleIndicator',
      afterDatasetsDraw(chart, args, plugins) {
        const { ctx, data } = chart;
        const meta = chart.getDatasetMeta(0);
        const angle = Math.PI / 180;

        // 计算百分比
        const percentage = Math.min(100, Math.floor((kra_amount / max_value) * 100));

        // 只在kra_amount大于0且小于max_value时显示圆圈指示器
        if(meta.data.length > 0 && kra_amount > 0 && kra_amount < max_value) {
          const dataPoint = meta.data[0]; // kra_amount对应的数据点

          if(chart.getDataVisibility(0) === true) {
            ctx.save();

            // 获取图表中心坐标
            const xCenter = dataPoint.x;
            const yCenter = dataPoint.y;
            ctx.translate(xCenter, yCenter);

            const endAngle = dataPoint.endAngle;
            const outerRadius = dataPoint.outerRadius;
            const innerRadius = dataPoint.innerRadius;

            // 计算中间位置 (在内半径和外半径之间)
            const middleRadius = (outerRadius + innerRadius) / 2;

            // 使用结束角度和中间半径定位
            const xPos = middleRadius * Math.cos(endAngle);
            const yPos = middleRadius * Math.sin(endAngle);

            // 绘制圆圈
            const radius = 12.75;
            ctx.beginPath();
            ctx.lineWidth = 5;
            ctx.strokeStyle = '#6CE3C4';
            ctx.fillStyle = '#6CE3C4';
            ctx.arc(xPos, yPos, radius, 0, angle * 360, false);
            ctx.stroke();
            ctx.fill();

            // 在圆圈中显示百分比值
            ctx.font = ' 12px poppins';
            ctx.fillStyle = 'black'; // 黑色文字
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(percentage + '%', xPos, yPos+1.33);

            ctx.restore();
          }
        }
      }
    };

    // 计算进度比 [0,1]
    const remainder = max_value - kra_amount;
    // 创建仅一个 dataset: [绿色进度, 灰色剩余]
    const chartInstance = new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [
          {
              // 如果超过了KRA max
            data:kra_amount>=max_value? [kra_amount]:[kra_amount, remainder],
            backgroundColor: ['#FFFFFF', '#3A3A3A'],
            borderWidth: 0,
            borderRadius: [
         // Arc #1 (kra_amount): round the left "outerStart" corner,
         // but square the boundary with the other arc ("outerEnd" = 0).
         { outerStart: 20, outerEnd:kra_amount>=max_value?20:0,innerEnd:kra_amount>=max_value?20:0,innerStart: 20},

         // Arc #2 (remainder): square the boundary with Arc #1
         // but round the right "outerEnd" corner.
         { outerStart: kra_amount === 0 ?20:0, outerEnd: 20, innerEnd: 20, innerStart:kra_amount === 0 ?20:0 },
       ],
          },
        ],
      },
      options: {
        circumference: 180, // 半圆
        rotation: -90,      // 从正上方开始
        cutout: '85%',      // 中心空心大小
        responsive: false,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
          }
        },
        animation: {
          duration: kra_amount === 0 ? 0 : 1000,
          animateRotate: kra_amount !== 0,

        },
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
      },
      plugins: [
        circleIndicator,
        {
          id: 'customLabels',
          afterDraw: (chart) => {
            const { ctx, chartArea } = chart;
            const { top, bottom, left, right } = chartArea;

            ctx.save();

            // ---------- 2) 在底部居中显示 "75K" + "KRA" ----------
            // 让它们贴近组件底部，比如 bottom - 10
            // (也可以跟 arc 中心做相对定位，这里演示简单方案)
            const centerTextX = (left + right) / 2;
            const bottomTextY = bottom - 20; // 靠近容器底部
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            // 大数字 e.g. "75K"
            ctx.fillStyle = '#6CE3C4';
            ctx.font = '24px Poppins';
            ctx.fillText(kra_amount.toLocaleString(), centerTextX, bottomTextY-8);

            // "KRA" 再往上 20px
            ctx.font = '24px Poppins';
            ctx.textBaseline = 'top';
            ctx.fillText('KRA', centerTextX, bottomTextY-4 );

          },
        },
      ],
    });

    return () => chartInstance.destroy();
  }, [kra_amount, max_value]);
  return (
    <div
      style={{
        width,
        height,
        backgroundColor: 'transparent',
        position: 'relative',
        display:'flex'
      }}
    ><div className={styles.progressText}>0</div>
      <canvas
        ref={canvasRef}
        width={"300px"}
        height={"180px"}
        style={{
          display: 'block',
          backgroundColor:'transparent',
          margin: '0 auto'
        }}
      />
      <div className={styles.progressText}>{formatNumbers(max_value)}</div>
    </div>
  );
}